import { cn } from "@dl/web-core-js/ui";
import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";

/**
 * A supplier's name as a link to its page, wherever a supplier is shown.
 *
 * <p>Inline text rather than {@link OpenRecord}'s arrow, because the name is
 * already on screen and is what people reach for. It stops the click from
 * reaching the row, so a list that opens a row on click still does everywhere
 * else on that row. Without an id it is the plain text: an order line with no
 * supplier, a row still loading.</p>
 */
export function SupplierLink({
  id,
  children,
  className,
}: {
  id: number | null | undefined;
  children: ReactNode;
  className?: string;
}) {
  if (id === null || id === undefined || id <= 0) return <span className={className}>{children}</span>;
  return (
    <Link
      to="/manufacturing/suppliers/$supplierId"
      params={{ supplierId: String(id) }}
      onClick={(event) => event.stopPropagation()}
      className={cn("text-accent hover:underline", className)}
    >
      {children}
    </Link>
  );
}
